import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
export default function EmptyTableState() {
  return /*#__PURE__*/_jsx(UIResultsMessage, {
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 200
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "goals-reporting-lib.table.emptyState"
    })
  });
}